import * as SubframeCore from "@subframe/core";

export const twClassNames = (...args: Parameters<typeof SubframeCore.twClassNames>) =>
  SubframeCore.twClassNames(...args);
